import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'
import DoctorFacetSearch from '../UI/UIComponent/doctorUIComponent/DoctorFacetSearch'
import DoctorDetailCard from '../UI/UIComponent/doctorUIComponent/DoctorDetailCard'
import './Page-style/doctor-consult.scss'
import DietPlanBanner from '../UI/Global-Component/DietPlanBanner'
import NonCarouselBanner from '../UI/Banner/NonCarouselBanner'
import PageBannerImage from '../assets/Images/DoctorConsultPage/Doc-spec-page-banner.webp'
import PageBannerImageMob from '../assets/Images/DoctorConsultPage/Doc-spec-page-banner-mob.png'
import {
  getAllDoctors,
  getSelectedDoctors,
} from '../api/services/doctor-service'
import PaginationComponent from '../UI/Global-Component/paginationComponent'
import CommonModal from '../UI/UIComponent/Modal/CommonModal'
import ConsultationBooking from '../FeatureComponent/QuickBooking/consultationBooking'
import OtpModal from '../UI/UIComponent/Modal/OtpModal'

export default function DoctorConsultationPage() {
  const [doctorList, setDoctorList] = useState([])
  const [dataLength, setDataLength] = useState()
  const [nextSlot, setNextSlot] = useState()
  const [pageNumber, setPageNumber] = useState()
  const [patientPayload, setpatientPayload] = useState({})
  const [encodedData, setEncodeddata] = useState()
  const { dept } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    setPageNumber(1)
    if (dept === 'all') {
      getDoctorDetails()
    } else {
      const params = {
        page: pageNumber,
        dept: dept,
      }
      getSelectedDoctors(params)
        .then((data) => {
          setDoctorList(data)
        })
        .catch((error) => console.log(error))
    }
  }, [])
  const handleCategoryFilter = (id) => {
    navigate(`/doctorlanding/doctorDetail/${id}`)
    const params = {
      page: pageNumber,
      dept: id,
    }
    getSelectedDoctors(params)
      .then((data) => {
        setDoctorList(data)
      })
      .catch((error) => console.log(error))
  }
  const getDoctorDetails = (pageNumber) => {
    getAllDoctors(pageNumber).then((data) => {
      setDataLength(data.totalDoctorCount)
      data.data.forEach((item) => {
        item.Address.forEach((element) => {
          const currentTime = new Date()
          const StartTimestamp = findNextAvailableSlot(element.StartTime)
          const Endtimestamp = findNextAvailableSlot(element.EndTime)
          if (StartTimestamp > currentTime.getTime()) {
            item.nextAvailableSlot = element.StartTime
          } else if (
            StartTimestamp < currentTime.getTime() &&
            Endtimestamp > currentTime.getTime()
          ) {
            item.nextAvailableSlot = `${currentTime.getHours()}:${currentTime.getMinutes()}`
          }
        })
      })

      setDoctorList(data.data)
    })
  }
  const findNextAvailableSlot = (time) => {
    const timeString = time
    //const endTimeString = EndTime;
    const today = new Date()
    //const today1 = new Date()
    //const currentTime = new Date()
    const [hours, minutes] = timeString.split(':').map(Number)
    //const [endHour, endMinutes] = endTimeString.split(':').map(Number)

    // Set the time on today's date
    today.setHours(hours)
    today.setMinutes(minutes)
    today.setSeconds(0)
    today.setMilliseconds(0)
    return today.getTime()
  }
  const handlePaginationChange = (page) => {
    const selectedPage = parseInt(page.target.textContent)
    setPageNumber(selectedPage)
    getDoctorDetails(selectedPage)
    document.documentElement.scrollTop = 400
  }
  const handleNavigateToDetail = (event) => {
    const selectedDocId = event.currentTarget.dataset.id
    let modalRef = document.getElementById('consultation-modal')
    modalRef.setAttribute('data-pageId', 'doctorPage')
    modalRef.setAttribute('data-consultationId', selectedDocId)
    modalRef.classList.add('show')
  }
  const handleBookNow = () => {
    let modalRef = document.getElementById('consultation-modal');
    modalRef.setAttribute('data-pageId', 'dietPlanWidget');
    modalRef.classList.add('show');
  }
  const handleCallback = (childData) => {
    setpatientPayload({ ...childData })
    setEncodeddata(childData.encodedData)
  }
  return (
    <>
      <CommonModal></CommonModal>
      <ConsultationBooking
        parentCallback={handleCallback}
      ></ConsultationBooking>
      <OtpModal
        patientInfoPayload={patientPayload}
        patientEncodedData={encodedData}
      ></OtpModal>
      <Header pageId={'3'}></Header>
      <section>
        <NonCarouselBanner
          ImageSrc={PageBannerImage}
          mobImageSrc={PageBannerImageMob}
          imageAlt="RHS doctor consultation"
          heading="Expert Care Made Simple"
          Subheading="Trusted medical support, advanced treatment and a healthier you."
          footNote="Book an appointment with our expert doctors and take the first step towards a healthier future."
          btnVisibility="true"
          isIconBannerEnable="true"
        ></NonCarouselBanner>
        <div className="container-fluid">
          <div className="container doctor-detail">
            <h2>Top Doctors Available</h2>
            <DoctorFacetSearch
              selectedItem={handleCategoryFilter}
            ></DoctorFacetSearch>
            <div className="body-section">
              {doctorList.length !== 0 ? (
                <div className="card-stack">
                  {doctorList.map((data, index) => (
                    <DoctorDetailCard
                      Heading={data.name}
                      subHead={data.doctorDept}
                      detailLabelText="Language Known"
                      detailLabelValue="Hindi, Bengali, English"
                      para2LabelText="Next Available at:"
                      para2LabelValue={data.nextAvailableSlot}
                      rightSeclabel="Consultation Fee"
                      rightSeclabelVal="399"
                      primaryBtnText="View Profile"
                      secondaryBtnText="Book an Appointment"
                      imageVal={data.doctorPhoto}
                      handleViewProfile={handleNavigateToDetail}
                      handleBookConsultation={handleNavigateToDetail}
                      doctorId={data.uid}
                    ></DoctorDetailCard>
                  ))}
                </div>
              ) : (
                <div className="card-stack">
                  <p>No Doctor Available</p>
                </div>
              )}

              <DietPlanBanner handleBookNow={handleBookNow}></DietPlanBanner>
            </div>
          </div>
        </div>
        <PaginationComponent
          pageLength={dataLength}
          paginationChange={handlePaginationChange}
          selectedPagination={pageNumber}
        ></PaginationComponent>
        <Footer></Footer>
      </section>
    </>
  )
}
